 
import * as React from "react";
interface Props extends React.ImgHTMLAttributes<HTMLImageElement>{
 
  className?:string,
  width?:number,
  height?:number 
}
export default function NCloodLogoIcon({width=40,height=40,className,...rest}:Props) {
  return (
     <img className={className} src={"/logo.png"} alt="App Logo" width={width} height={height} {...rest}></img>
  );
}